"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var authWidget = function () {
  var isErrorModalDisplayed = false;
  var iti = null;
  var authWidgetParams = {
    model: {},
    url: {},
    template: {}
  };

  function getUrls() {
    return authWidgetParams.url;
  }

  function hideResetPasswodBlock() {
    if ($('#Password').length > 0) {
      $('.js-auth-reset-block').show();
    } else {
      $('.js-auth-reset-block').hide();
    }
  }

  function authorizeUser(action, data) {
    $.ajax({
      type: 'POST',
      url: action,
      data: data,
      success: function success(response) {
        var redirectUrlTitle = authWidgetParams.url.backUrl;

        if (response.indexOf('selflogout') > -1) {
          redirectUrlTitle = '/Sitefinity/SignOut/selflogout';
        }

        window.history.replaceState('', 'Title', redirectUrlTitle);
        $.get("".concat(authWidgetParams.url.login, "?err=false"));
        var newDoc = document.open('text/html', 'replace');
        newDoc.write(response);
        newDoc.close();
      },
      error: function error() {
        location.href = authWidgetParams.url.backUrl;
        modalDialog.showBaseWnd({
          title: 'Ошибка авторизации',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'Пожалуйста, проверьте правильность введенных данных';
          },
          onClose: function onClose() {
            isErrorModalDisplayed = false;
          }
        });
        isErrorModalDisplayed = true;
      },
      complete: function complete() {
        modalDialog.busyIndicator(false);
      }
    });
  }

  function getCaptchaField(captchaModel, callback) {
    $.ajax({
      type: 'POST',
      url: authWidgetParams.url.captcha,
      data: {
        capthaModel: captchaModel
      },
      success: function success(response) {
        callback(response);
      }
    });
  }

  function renderCaptcha(captchaModel) {
    getCaptchaField(captchaModel, function (response) {
      var $captcha = $(response).find('#googleCaptcha_shared');
      var $captchaField = $('#authCaptchaField');
      $captchaField.removeClass('-hidden');
      $captchaField.find('.field-input').empty().append($captcha);
    });
  }

  function loginUser(data) {
    $.ajax({
      url: authWidgetParams.url.login,
      type: 'POST',
      data: data,
      success: function success(response) {
        if (_typeof(response) === 'object') {
          modalDialog.busyIndicator(false);

          if (response.CaptchaModel.ErrorMessage !== null) {
            modalDialog.showBaseWnd({
              title: 'Ошибка авторизации',
              buttons: [{
                title: 'Хорошо',
                big: true,
                primary: true
              }],
              onDrawContent: function onDrawContent() {
                return response.CaptchaModel.ErrorMessage;
              },
              onClose: function onClose() {
                isErrorModalDisplayed = false;
              }
            });
            isErrorModalDisplayed = true;
          }

          if (response.CaptchaModel.ShowCaptcha) {
            renderCaptcha(response.CaptchaModel);
          }
        } else {
          var hasAuthForm = false;
          $(response).each(function () {
            if ($(this).is('form')) {
              var $loginForm = $(this);
              var action = $loginForm.attr('action');
              var fData = $loginForm.serialize();
              authorizeUser(action, fData);
              hasAuthForm = true;
            }
          });

          if (!hasAuthForm) {
            modalDialog.busyIndicator(false);
            modalDialog.showBaseWnd({
              title: 'Ошибка авторизации',
              buttons: [{
                title: 'Хорошо',
                big: true,
                primary: true
              }],
              onDrawContent: function onDrawContent() {
                return 'Пожалуйста, проверьте правильность введенных данных';
              },
              onClose: function onClose() {
                isErrorModalDisplayed = false;
              }
            });
            isErrorModalDisplayed = true;
          }
        }
      },
      error: function error() {
        modalDialog.busyIndicator(false);
        modalDialog.showBaseWnd({
          title: 'Ошибка авторизации',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'Пожалуйста, проверьте правильность введенных данных';
          },
          onClose: function onClose() {
            isErrorModalDisplayed = false;
          }
        });
        isErrorModalDisplayed = true;
      }
    });
  }

  function checkPhone(data) {
    $.ajax({
      url: authWidgetParams.url.phoneAuth,
      type: 'POST',
      data: data,
      success: function success(response) {
        modalDialog.busyIndicator(false);

        if (_typeof(response) === 'object') {
          if (!response.Success) {
            modalDialog.showBaseWnd({
              title: 'Ошибка авторизации',
              buttons: [{
                title: 'Хорошо',
                big: true,
                primary: true
              }],
              onDrawContent: function onDrawContent() {
                return response.Result;
              },
              onClose: function onClose() {
                isErrorModalDisplayed = false;
              }
            });
            isErrorModalDisplayed = true;
          }
        } else {
          $("div.area-section-content.mainAuthDiv").html(response);
          if ($("input[type='tel']").data('mask') == undefined) LKCommon.initTelMask();
          var timer = $("div.validation-message span.timer");

          if (timer.length) {
            modalCodeCountdown.timerOn = true;
            modalCodeCountdown.timer(timer.data("timeout"), timer, function () {
              $("#acceptBtn").hide();
              $("#resendBtn").show();
            });
          }
        }

        hideResetPasswodBlock();
      },
      error: function error() {
        modalDialog.busyIndicator(false);
        modalDialog.showBaseWnd({
          title: 'Ошибка авторизации',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'Пожалуйста, проверьте правильность введенных данных';
          },
          onClose: function onClose() {
            isErrorModalDisplayed = false;
          }
        });
        isErrorModalDisplayed = true;
      }
    });
  }

  function checkCode(data) {
    $.ajax({
      url: authWidgetParams.url.checkCode,
      type: 'POST',
      data: data,
      success: function success(response) {
        modalDialog.busyIndicator(false);

        if (!response.Success) {
          modalDialog.showBaseWnd({
            title: 'Ошибка авторизации',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return response.Result;
            },
            onClose: function onClose() {
              isErrorModalDisplayed = false;
            }
          });
          isErrorModalDisplayed = true;
        } else {
          modalDialog.busyIndicator(true);
          location.href = authWidgetParams.url.authUserUrl;
        }
      },
      error: function error() {
        modalDialog.busyIndicator(false);
        modalDialog.showBaseWnd({
          title: 'Ошибка авторизации',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'Пожалуйста, проверьте правильность введенных данных';
          },
          onClose: function onClose() {
            isErrorModalDisplayed = false;
          }
        });
        isErrorModalDisplayed = true;
      }
    });
  }

  var modalCodeCountdown = {
    timerOn: true,
    timer: function timer(remaining, span, callback) {
      // $('#check-validate-error').text('');
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      span.html("\u041A\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0435\u0449\u0435: ".concat(m, ":").concat(s, " \u0441\u0435\u043A."));
      remaining -= 1;

      if (remaining >= 0 && modalCodeCountdown.timerOn) {
        setTimeout(function () {
          modalCodeCountdown.timer(remaining, span, callback);
        }, 1000);
        return;
      } else {
        span.html('Время действия кода закончилось.');
        callback();
      }

      if (!modalCodeCountdown.timerOn) {
        return;
      } // Do timeout stuff here

    }
  };

  function testEmail(email) {
    var reg = new RegExp('^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$');
    return reg.test(email.toLowerCase());
  }

  function testPhone(phone) {
    var phoneRgx = /^((\+[\d]{1,3})[\- ]?)[\d]{6,12}$/;
    return phoneRgx.test(phone);
  }

  function formatPhoneNumber(phone) {
    return phone.replace(/[^+\d]/g, '');
  }

  function submitLoginForm() {
    if (!iti) {
      iti = window.intlTelInputGlobals.getInstance($('#Phone')[0]);
    } else if (!$('#acceptBtn').length) {
      var ins = window.intlTelInputGlobals.instances.length;
      iti = window.intlTelInputGlobals.instances[ins];

      if (!iti) {
        iti = window.intlTelInputGlobals.getInstance($('#Phone')[0]);
      }
    }

    var logInput = $("#Phone").length ? $('#Phone') : $("#UserName");
    var loginValue = $("#Phone").length ? iti.getNumber(intlTelInputUtils.numberFormat.E164) : logInput.val().trim();
    var byPhone = logInput.data("auth-type") == "phone";

    if (!testEmail(loginValue) && !testPhone(loginValue)) {
      modalDialog.showBaseWnd({
        title: 'Неверный формат логина',
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true
        }],
        onDrawContent: function onDrawContent() {
          return 'Пожалуйста, проверьте корректность введенных данных';
        },
        onClose: function onClose() {
          isErrorModalDisplayed = false;
        }
      });
      return;
    } else {
      if (testPhone(loginValue)) {
        loginValue = formatPhoneNumber(loginValue);
      }
    }

    var data = {
      Phone: byPhone ? loginValue : null,
      Password: $('#Password').val(),
      Code: $('#Code').val(),
      RememberMe: true,
      BackUrl: authWidgetParams.url.backUrl,
      'g-recaptcha-response': $('.g-recaptcha-response').val()
    };

    if (byPhone) {
      if ($("#UserName").length) {
        var lv = $("#UserName").val().trim();

        if (!testEmail(lv) && !testPhone(lv)) {
          modalDialog.showBaseWnd({
            title: 'Неверный формат логина',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return 'Пожалуйста, проверьте корректность введенных данных';
            },
            onClose: function onClose() {
              isErrorModalDisplayed = false;
            }
          });
          return;
        } else {
          if (testPhone(lv)) {
            lv = formatPhoneNumber(lv);
          }
        }

        data.userName = lv;
      }
    } else data.userName = loginValue;

    if (!isErrorModalDisplayed) {
      modalDialog.busyIndicator(true);

      if (byPhone) {
        if (data.Code == undefined || $("#resendBtn").is(":visible")) {
          checkPhone(data);
        } else {
          checkCode(data);
        }
      } else loginUser(data);
    }
  }

  function restore() {
    getAuthForm("_PhoneAuth", LKCommon.initTelMask);
  }

  function classic() {
    getAuthForm("_ClassicAuth", LKCommon.initTelMask);
  }

  function getAuthForm(action, callback) {
    modalDialog.busyIndicator(true);
    var data = {
      action: action,
      ReturnUrl: authWidgetParams.url.backUrl
    };
    $.ajax({
      url: authWidgetParams.url.authForm,
      type: 'POST',
      data: data,
      success: function success(response) {
        modalDialog.busyIndicator(false);
        $("div.area-section-content.mainAuthDiv").html(response);
        hideResetPasswodBlock();
        callback();
      },
      error: function error() {
        modalDialog.busyIndicator(false);
        modalDialog.showBaseWnd({
          title: 'Ошибка авторизации',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'Пожалуйста, проверьте правильность введенных данных';
          },
          onClose: function onClose() {
            isErrorModalDisplayed = false;
          }
        });
        isErrorModalDisplayed = true;
      }
    });
  }

  function unbindHandlers() {
    $(document).off('click', '#loginBtn');
    $(document).off('click', '#acceptBtn');
    $(document).off('click', '#resendBtn');
    $(document).off('click', '#cancelBtn'); //$(document).off('dblclick', '.classicFormSelecter');

    $(document).off('click', '#resetPhoneForm');
  }

  function setParams(loginParams) {
    authWidgetParams = $.extend({}, authWidgetParams, loginParams);
  }

  function bindHandlers() {
    $(document).on('keypress', function (e) {
      if (e.which === 13) {
        submitLoginForm();
      }
    });
    $(document).on('click', '#loginBtn', submitLoginForm);
    $(document).on('click', '#acceptBtn', submitLoginForm);
    $(document).on('click', '#resendBtn', submitLoginForm);
    $(document).on('click', '#cancelBtn', restore); //$(document).on('dblclick', '.classicFormSelecter', classic);

    $(document).on('click', '#resetPhoneForm', restore);
  }

  function init(loginParams) {
    unbindHandlers();
    setParams(loginParams);
    bindHandlers();
    hideResetPasswodBlock();
  }

  return {
    init: init,
    getUrls: getUrls
  };
}();